"use client";

import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { LoyaltyReferralCodeExtended as UiLoyaltyReferralCodeExtended } from "@jti/ui/components/LoyaltyReferralCode/components/LoyaltyReferralCodeExtended";

import type { loyaltyReferralCodeExtendedInputs } from "./LoyaltyReferralCodeExtended.builder";

type LoyaltyReferralCodeExtendedBuilderProps = BuilderComponentProps<typeof loyaltyReferralCodeExtendedInputs>;

export const LoyaltyReferralCodeExtended: FC<LoyaltyReferralCodeExtendedBuilderProps> = ({
  heading,
  label,
  list,
  legalText,
  discountImageDesktop,
  discountImageTablet,
  discountImageMobile,
  discountHeading,
  discountLabel,
  discountSubText,
  successImageDesktop,
  successImageMobile,
  successHeading,
  successLabel,
  successBtnLabel,
  successLink,
  inputLabel,
  inputPlaceholder,
  inputHelperText,
  btnText,
  validationRequiredMessage,
  verifyErrorMessage,
  isHidden,
}) => {
  return (
    <UiLoyaltyReferralCodeExtended
      heading={heading}
      label={label}
      list={list}
      legalText={legalText}
      discountImageDesktop={discountImageDesktop}
      discountImageTablet={discountImageTablet}
      discountImageMobile={discountImageMobile}
      discountHeading={discountHeading}
      discountLabel={discountLabel}
      discountSubText={discountSubText}
      successImageDesktop={successImageDesktop}
      successImageMobile={successImageMobile}
      successHeading={successHeading}
      successLabel={successLabel}
      successBtnLabel={successBtnLabel}
      successLink={successLink}
      inputLabel={inputLabel}
      inputPlaceholder={inputPlaceholder}
      inputHelperText={inputHelperText}
      btnText={btnText}
      validationRequiredMessage={validationRequiredMessage}
      verifyErrorMessage={verifyErrorMessage}
      isHidden={isHidden}
      isInEditor={isEditing()}
    />
  );
};
